import styled from "styled-components";
// Path assumes this file lives at
// src/components/sections/WelcomeScreen/DietPlan/EmailPopup.styles.js
import { DIET_C } from "../../../common/colors";

// ═══════════════════════════════════════════════════════════════════════════════
// EMAIL POPUP
// Modal overlay — not scoped inside AssessmentStepShell, same literal
// --c-*/--sp-* fallback approach as DietPlanScreen.styles.js.
// ═══════════════════════════════════════════════════════════════════════════════

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-4, 16px);
  z-index: 1000;
`;
Overlay.displayName = "Overlay";

export const Modal = styled.div`
  width: 100%;
  max-width: 400px;
  background: var(--c-bg, #fff);
  border-radius: var(--r-sm, 12px);
  padding: var(--sp-5, 24px);
`;
Modal.displayName = "Modal";

export const ModalTitle = styled.h2`
  margin: 0 0 4px;
  color: var(--c-text, #1a1a1a);
  font-size: 1.1rem;
  font-weight: 800;
`;
ModalTitle.displayName = "ModalTitle";

export const ModalSubtitle = styled.p`
  margin: 0 0 var(--sp-4, 16px);
  color: var(--c-text-muted, #666);
  font-size: 0.85rem;
`;
ModalSubtitle.displayName = "ModalSubtitle";

export const FieldGroup = styled.div`
  margin-bottom: var(--sp-4, 16px);
`;
FieldGroup.displayName = "FieldGroup";

export const FieldLabel = styled.label`
  display: block;
  color: var(--c-text, #1a1a1a);
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 6px;
`;
FieldLabel.displayName = "FieldLabel";

export const EmailInput = styled.input.attrs({ type: "email" })`
  width: 100%;
  height: 44px;
  padding: 0 12px;
  border-radius: var(--r-sm, 8px);
  background: var(--c-surface, #fafafa);
  color: var(--c-text, #1a1a1a);
  font-size: 0.92rem;
  border: 1px solid ${({ $error }) => ($error ? DIET_C.accent : `${DIET_C.secondary}88`)};

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }
`;
EmailInput.displayName = "EmailInput";

export const ErrorText = styled.p`
  color: ${DIET_C.accent};
  font-size: 0.78rem;
  font-weight: 600;
  margin: 4px 0 0;
`;
ErrorText.displayName = "ErrorText";

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: var(--c-text, #1a1a1a);
  cursor: pointer;
  margin-bottom: var(--sp-4, 16px);
`;
CheckboxRow.displayName = "CheckboxRow";

export const ButtonRow = styled.div`
  display: flex;
  gap: 10px;
`;
ButtonRow.displayName = "ButtonRow";

export const SubmitButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 999px;
  background: ${DIET_C.primary};
  color: #fff;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  border: none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
SubmitButton.displayName = "SubmitButton";

export const CancelButton = styled.button`
  padding: 0 18px;
  height: 44px;
  border-radius: 999px;
  background: transparent;
  color: var(--c-text-muted, #666);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${DIET_C.secondary}66;
`;
CancelButton.displayName = "CancelButton";

export const ConfirmationText = styled.p`
  color: ${DIET_C.primary};
  font-size: 0.92rem;
  font-weight: 600;
  text-align: center;
  margin: var(--sp-2, 8px) 0 var(--sp-4, 16px);
`;
ConfirmationText.displayName = "ConfirmationText";
